export const GET_RECEIVED_LIKES = 'GET_RECEIVED_LIKES'
export const GET_SENT_LIKES = 'GET_SENT_LIKES'
export const SET_CURRENT_USER_ID = 'SET_CURRENT_USER_ID'
export const PUSH_RECEIVED_LIKES = 'PUSH_RECEIVED_LIKES'
export const PUSH_SENT_LIKES = 'PUSH_SENT_LIKES'
export const REMOVE_RECEIVED_LIKE_BY_ID = 'REMOVE_RECEIVED_LIKE_BY_ID'
export const REMOVE_SENT_LIKE_BY_ID = 'REMOVE_SENT_LIKE_BY_ID'
